/**
 * Erro de quem deixou a promessa estourar o prazo em `comPrazo` — para as
 * chamadas que não aceitam o `timeout` do axios.
 */
export class PrazoEsgotadoError extends Error {
  constructor() {
    super('A consulta demorou demais para responder.');
    this.name = 'PrazoEsgotadoError';
  }
}

/**
 * A falha é PASSAGEIRA (rede caiu, timeout, servidor fora) ou é uma resposta de
 * verdade da API (403 de permissão, 404 de rota que não existe)?
 *
 * Telas com polling usam isso para decidir entre manter o último dado bom
 * (passageira: a próxima rodada resolve) e aceitar o vazio (resposta: repetir
 * não muda nada, e segurar dado velho esconderia a regra da API).
 */
export function ehFalhaTransitoria(erro: any): boolean {
  if (erro instanceof PrazoEsgotadoError) return true;

  const status = erro?.response?.status;
  if (typeof status === 'number') {
    // 501 é "rota não publicada" (ver service/entregas e service/apontamentos).
    return status === 408 || status === 429 || (status >= 500 && status !== 501);
  }

  // Erro do axios sem resposta: a requisição nem chegou ou nunca voltou.
  return erro?.isAxiosError === true;
}

/** Rejeita com `PrazoEsgotadoError` se a promessa não terminar em `ms`. */
export function comPrazo<T>(promessa: Promise<T>, ms: number): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    const timer = setTimeout(() => reject(new PrazoEsgotadoError()), ms);
    promessa.then(
      (valor) => {
        clearTimeout(timer);
        resolve(valor);
      },
      (erro) => {
        clearTimeout(timer);
        reject(erro);
      }
    );
  });
}
